import React, { Component } from 'react'
import { css } from 'emotion'
import { COLOR } from 'cf-web/src/styles'

class CFText extends Component {
  render() {
    const {
      children,
      style: customStyle,
      className: customClassName,
      onClick,
      ...props
    } = this.props

    // 1. Apply base style
    const style = [styles.baseStyle]

    // 2. Apply prop styles
    const keys = Object.keys(props)
    for (const key of keys) {
      if (props[key] === true && styles[key]) {
        style.push(styles[key])
      }

      switch (key) {
        case 'color':
          style.push(css({ color: props[key] }))
          break
        default:
          break
      }
    }

    // 3. Apply customStyle passed down as this.props.style
    style.push(customStyle)
    style.push(customClassName)

    return (
      <span className={css(style)} onClick={onClick}>
        {children}
      </span>
    )
  }
}

const styles = {
  baseStyle: css({
    fontFamily: 'roboto',
  }),
  robotobold: css({
    fontFamily: 'roboto-black',
  }),
  dark: css({
    color: COLOR.black,
  }),
  black: css({
    color: COLOR.black,
  }),
  red: css({
    color: COLOR.red,
  }),
  grey: css({
    color: COLOR.darkGrey,
  }),
  white: css({
    color: COLOR.white,
  }),
  gold: css({
    color: COLOR.Gold,
  }),
  primary: css({
    color: '#36B7EE',
  }),
  block: css({
    display: 'inline-block',
  }),
  disabled: css({
    color: 'rgba(255,255,255,0.6)',
  }),
  heading: css({
    fontFamily: 'futura',
  }),
  heading2: css({
    fontFamily: 'antonio',
  }),
  dafoe: css({
    fontFamily: 'dafoe',
  }),
  dolce: css({
    fontFamily: 'dolce',
  }),
  din: css({
    fontFamily: 'din',
  }),
  raleway: css({
    fontFamily: 'raleway',
  }),
  tech: css({
    fontFamily: 'tech',
  }),
  chalk: css({
    fontFamily: 'chalkduster',
  }),
  painting: css({
    fontFamily: 'painting',
  }),
  blowbrush: css({
    fontFamily: 'blowbrush',
  }),
  amatic: css({
    fontFamily: 'amatic',
  }),
  center: css({
    textAlign: 'center',
  }),
  right: css({
    textAlign: 'right',
  }),
  superhero: css({
    fontSize: 50,
  }),
  hero: css({
    fontSize: 40,
  }),
  h1: css({
    fontSize: 36,
  }),
  h2: css({
    fontSize: 24,
  }),
  h3: css({
    fontSize: 20,
  }),
  h4: css({
    fontSize: 18,
  }),
  h5: css({
    fontSize: 16,
  }),
  h6: css({
    fontSize: 14,
  }),
  h7: css({
    fontSize: 12,
  }),
  xBold: css({
    fontWeight: '900',
  }),
  bold: css({
    fontWeight: '700',
  }),
  thin: css({
    fontWeight: '300',
  }),
  xThin: css({
    fontWeight: '100',
  }),
}

export default CFText
